import { render, staticRenderFns } from "./CardFillText.vue?vue&type=template&id=5ede10f2&scoped=true"
import script from "./CardFillText.vue?vue&type=script&lang=js"
export * from "./CardFillText.vue?vue&type=script&lang=js"
import style0 from "./CardFillText.vue?vue&type=style&index=0&id=5ede10f2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ede10f2",
  null
  
)

export default component.exports